export default [{
    text: 'Отдельный со двора',
    value: 'separateFromYard'
}, {
    text: 'Отдельный с улицы',
    value: 'separateFromStreet'
}, {
    text: 'Общий со двора',
    value: 'commonFromYard'
}, {
    text: 'Общий с улицы',
    value: 'commonFromStreet'
}];
